import { API_BASE_URL } from './api';

class BusinessUpgradeService {
  async getMyRequest() {
    const res = await fetch(`${API_BASE_URL}/business-upgrade/me`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to fetch upgrade request');
    return res.json();
  }

  async submitRequest() {
    const res = await fetch(`${API_BASE_URL}/business-upgrade`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include'
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to submit upgrade request');
    return data;
  }

  async getAllRequests(status) {
    const params = status ? `?status=${status}` : '';
    const res = await fetch(`${API_BASE_URL}/business-upgrade${params}`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to fetch upgrade requests');
    return res.json();
  }

  async approveRequest(id) {
    const res = await fetch(`${API_BASE_URL}/business-upgrade/${id}/approve`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include'
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to approve request');
    return data;
  }

  async rejectRequest(id, reason) {
    const res = await fetch(`${API_BASE_URL}/business-upgrade/${id}/reject`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ reason })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to reject request');
    return data;
  }
}

const businessUpgradeService = new BusinessUpgradeService();
export default businessUpgradeService;
